import { Badge } from "primereact/badge";
import { Checkbox } from "primereact/checkbox";

export const columns=[    
       { 
        field: "name", 
        header: "Name",
        accessor: (row,handleCellClick) => (
            <>
              <div  onClick={()=>handleCellClick(row,"roleId")}  className="">          
                <p className="w-[6rem] cursor-pointer text-blue-600 hover:text-blue-800" >
                {row?.name||""}
                </p>
              </div>
            </>
          ),
       },      
       { 
        field: "taxes", 
        header: "Taxes",
        accessor: (row,handleCellClick) => (
            <>
              <div  onClick={()=>handleCellClick(row,"component")}  className="">          
                <p className="w-[6rem]" >
                {row?.taxes?.map((d)=>(<>{d.name}@{d.rate?.$numberDecimal}, </>))||""}
                </p>
              </div>
            </>
          ),
       },      
       
       { 
        field: "active", 
        header: "Active",
        accessor: (row,handleCellClick) => (
            <>
              <div  onClick={()=>handleCellClick(row,"active")}  className="">          
                <p className="w-[6rem]">                    
                 <Badge
                  className="w-[6rem]"
                  severity={
                    row?.active === true
                      ? "success"
                      : "danger"
                  }
                  value={row?.active?"Enabled":"Disabled"}
                ></Badge>          
                </p>
              </div>
            </>
          ), 
       },
]

export const searchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending ",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};